module.exports = __webpack_public_path__ + "static/media/progress-bar-bg.a4ecf1d4.png";